module.exports = __webpack_public_path__ + "img/white-bg-cs-logo-fundo-escuro.222e6c05.png";